// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import { Outlet } from "react-router-dom";

// const Dashboard = () => {
//   const [collapsed, setCollapsed] = useState(false);

//   return (
//     <div className="flex flex-col h-screen bg-[#f9f9fb] overflow-hidden ">
//       <Header collapsed={collapsed} />
//       <div className="flex flex-1 overflow-hidden">
//       <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
//         <div className="p-6 overflow-auto flex-1">
//           <Outlet /> {/* Child routes like overview, users, branches go here */}
//         </div>
//       </div>
//     </div>
//   );
// };
 
// export default Dashboard;
// import React, { useState } from "react";
// import Header from "../components/Header";
// import Sidebar from "./Sidebar";
// import { Outlet } from "react-router-dom";

// const Layout = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [showMobileSidebar, setShowMobileSidebar] = useState(false);
//   const toggleSidebar = () => {
//     setShowMobileSidebar(!showMobileSidebar);
//   };

//   return (
//     <div className="flex flex-col h-screen bg-surface overflow-hidden">
//       <Header 
//         collapsed={collapsed} 
//         toggleSidebar={toggleSidebar} 
//         showMobileSidebar={showMobileSidebar} 
//       />
//       <div className="flex flex-1 overflow-hidden">
//         <Sidebar 
//           collapsed={collapsed} 
//           setCollapsed={setCollapsed} 
//           showMobileSidebar={showMobileSidebar} 
//           toggleSidebar={toggleSidebar} 
//         />
//         <div 
//           id="scrollable-container" 
//           className="overflow-auto flex-1 px-2 py-6 md:px-4 bg-surface"
//         >
//           <Outlet /> {/* Child routes like overview, users, branches go here */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

// import React, { useState } from "react";
// import Header from "../components/Header";
// import Sidebar from "./Sidebar";
// import { Outlet } from "react-router-dom";

// const Layout = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [showMobileSidebar, setShowMobileSidebar] = useState(false);

//   const toggleSidebar = () => {
//     setShowMobileSidebar((prev) => !prev);
//   };

//   return (
//     <div className="flex flex-col h-screen bg-surface overflow-hidden">
//       <Header
//         collapsed={collapsed}
//         toggleSidebar={toggleSidebar}
//         showMobileSidebar={showMobileSidebar}
//       />

//       <div className="flex flex-1 overflow-hidden">
//         <Sidebar
//           collapsed={collapsed}
//           setCollapsed={setCollapsed}
//           showMobileSidebar={showMobileSidebar}
//           toggleSidebar={toggleSidebar}
//         />

//         <div
//           id="scrollable-container"
//           className="overflow-auto flex-1 px-2 py-6 md:px-4 bg-surface"
//         >
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;


import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "./Sidebar"; // Adjust path as needed
import { Outlet } from "react-router-dom";

const Layout = () => {
  // State for Desktop Collapse (Default: Expanded)
  const [collapsed, setCollapsed] = useState(false);
  
  // State for Mobile Drawer (Default: Closed)
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileSidebar = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      
      {/* Header (Full Width) */}
      <Header toggleMobileSidebar={toggleMobileSidebar} />

      {/* Main Container (Sidebar + Content) */}
      <div className="flex flex-1 overflow-hidden relative">
        
        {/* Sidebar */}
        <Sidebar 
          collapsed={collapsed} 
          setCollapsed={setCollapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        {/* admin-scroll-area is used in ScrollToTop component Area */}
        <main id="admin-scroll-area" className="flex-1 overflow-auto p-4 md:p-6 bg-white">
          <Outlet /> 
        </main>
        
      </div>
    </div>
  );
};

export default Layout;